import DistanceSelectSlider from "./DistanceSelectSlider";

export default DistanceSelectSlider;
